import { makeStyles } from "@mui/styles";

const useDyanamicGalleryStyle = makeStyles(() => ({
  activeColor: {
    color: "#4B9EF9",
  },
  toolbarButton: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    height: "36px",
    minWidth: "36px",
    padding: "0 12px",
    borderRadius: "6px",
    border: "1px solid #D9DBE9",
    backgroundColor: "#ffffff",
    color: "#2d2d39",
    cursor: "pointer",
    flexShrink: 0,
    justifyContent: "center",
    whiteSpace: "nowrap",
    "&:hover": {
      borderColor: "#B4B7C4",
    },
    "&.active": {
      backgroundColor: "#14142B",
      borderColor: "#14142B",
      color: "#ffffff",
    },
    "&.disabled": {
      opacity: 0.5,
      cursor: "not-allowed",
      pointerEvents: "none",
    },
    "& .toolbarButtonLabel.Platform-x-Typography-root": {
      color: "inherit",
      lineHeight: 1,
      margin: 0,
    },
    "&:focus-visible": {
      outline: "2px solid #1E64ED",
      outlineOffset: "2px",
    },
    "& .toolbarButtonBadge": {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      minWidth: "18px",
      height: "18px",
      padding: "0 5px",
      borderRadius: "9px",
      backgroundColor: "#0E7C3A",
      color: "#ffffff",
      fontSize: "11px",
      lineHeight: "18px",
    },
    "& .toolbarButtonDot": {
      width: "8px",
      height: "8px",
      borderRadius: "50%",
      backgroundColor: "#0E7C3A",
      flexShrink: 0,
    },
  },
  galleryToolbar: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flexWrap: "wrap",
    justifyContent: "flex-end",
  },
}));

export default useDyanamicGalleryStyle;
